import 'dayjs/locale/ru';
import axios from 'axios';
import dayjs from 'dayjs';
import Observer from '../../common/scripts/observer';
// import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class CompareButton {
    constructor() {
        /**
         * Массив с ID элементов в сравнении
         * @type {array}
         */
        this.compare = [];

        /**
         * Массив со всеми кнопками сравнения на страничке
         * @type {null|array}
         */
        this.compareButtons = null;
        this.compareButtonsTooltips = null;

        /**
         * Активный класс
         * @type {string}
         */
        this.activeClass = 'is-active';

        /**
         * Класс, помечающий кнопку избранного,
         * на которую кликнули первой (убирается после синхронизации)
         * @type {string}
         */
        this.initClass = 'is-first-init';

        /**
         * Блоки "вернуть назад в сравнение" в карточке квартиры
         * @type {*[]}
         */
        this.returnBlocks = [];

        this.parent = null;

        /**
         * Адрес запросов на сервер
         * @type {string}
         */
        this.action = '/api/estate/premises/compare';

        /**
         * Тип запроса
         * @type {string}
         */
        this.requestType = '';

        /**
         * Тип недвижимости - по умолчанию flats, для коммерции надо переопределить
         * @type {string}
         */
        this.estateType = 'flats';
    }

    init(options) {
        this.compareButtons = options.compareButtons;
        this.compareButtonsTooltips = this.compareButtons?.map((button) => {
            return button.querySelector('.j-button__tooltip');
        });

        this._getCompare();

        this._bindEvents();
    }

    _getCompare() {
        const chosenFlats = document.querySelectorAll('.j-compare.is-active');

        chosenFlats.forEach((item) => {
            this.compare.push(item.getAttribute('data-id'));
        });

        const uniqueFavSet = new Set(this.compare);

        this.compare = [...uniqueFavSet];
    }

    /**
     * Навешиваем обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.compareButtons.length) {
            return;
        }

        this.compareButtons.forEach((button) => {
            const id = button.dataset.id;
            const title = button.dataset.title;
            const tooltip = button.querySelector('.j-button__tooltip');
            const closeButton = button.querySelector('.j-tooltip__close');
            const parent = button.closest('.j-parametric-flat');

            button.setAttribute('data-init', true);

            button.addEventListener('click', (event) => {
                event.preventDefault();

                this.parent = button.closest('.j-compare-flat');

                this._checkIsDisabledFlat(button);

                this._setCompare(id, parent);

                button.classList.toggle(this.activeClass);
                button.classList.add(this.initClass);

                this._syncCompare(id);

                const removed = this.compareButtonsTooltips.filter((innerTooltip) => {
                    const isOpened = innerTooltip.classList.contains('force-tooltip-open');

                    if (isOpened) {
                        innerTooltip.classList.remove('force-tooltip-open');
                    }

                    return isOpened;
                });

                if (removed.length) {
                    setTimeout(() => {
                        this._setTooltip(tooltip, button.classList.contains(this.activeClass), title);
                    }, 300);
                } else {
                    this._setTooltip(tooltip, button.classList.contains(this.activeClass), title);
                }

                setTimeout(() => {
                    this._setTooltip(tooltip, button.classList.contains(this.activeClass));
                }, 2500);
            });

            closeButton?.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                this._setTooltip(tooltip, button.classList.contains(this.activeClass));
            });
        });

        if (!this.returnBlocks.length) {
            return;
        }

        this.returnBlocks.forEach((item) => {
            item.button.addEventListener('click', (event) => {
                event.preventDefault();
                this._setCompare(item.id);

                item.compareButton.classList.toggle(this.activeClass);
                item.compareButton.classList.add(this.initClass);

                this._syncCompare(item.id);
            });
        });
    }

    /**
     * Меняет текст в тултипе
     * @param {HTMLElement} tooltip - тултип конкретной кнопки
     * @param {boolean} isActive - активна ли кнопка
     * @param {string} title - название квартиры
     * @private
     */
    _setTooltip(tooltip, isActive, title = '') {
        if (!tooltip) {
            return;
        }

        const innerSpan = tooltip.querySelector('span');

        if (title) {
            const action = isActive ? 'Добавлено' : 'Удалено';
            const date = dayjs().locale('ru')
                .format('HH:mm, D MMMM YYYY');

            tooltip.classList.add('force-tooltip-open');

            innerSpan.innerHTML = `
                <div class="tooltip__action">${action}</div>
                <div class="tooltip__title">${title}</div>
                <div class="tooltip__date">${date}</div>
            `;
        } else {
            this.compareButtonsTooltips.forEach((innerTooltip) => {
                innerTooltip.classList.remove('force-tooltip-open');
            });
        }
    }

    /**
     * Сихнронизирует квартиры на странице:
     * когда добавляем к сравнению квартиру из шахматки,
     * та же самая квартира в табличном виде тоже должна обновиться
     * @param {string} id - id элемента
     */
    _syncCompare(id) {
        this.compareButtons.forEach((item) => {
            if (item.getAttribute('data-id') === id && !item.classList.contains(this.initClass)) {
                item.classList.toggle(this.activeClass);
            }
        });

        this.compareButtons.forEach((item) => {
            if (item.classList.contains(this.initClass)) {
                item.classList.remove(this.initClass);
            }
        });
    }

    /**
     * Записываем или удаляем id элемента в локальном хранилище
     * @param {string} id - id элемента
     * @param {string} parent - parent элемента
     */
    _setCompare(id, parent) {
        this._getCompare();
        // Проверяем, есть ли элемент в массиве
        let isExist = -1;

        if (this.compare.length) {
            isExist = this.compare.findIndex((item) => {
                return item === id;
            });
        }

        // Если есть, удаляем, если нет - сохраняем в массив
        if (isExist > -1) {
            this.compare.splice(isExist, 1);
            this._showReturnBlock(id);
            this.requestType = 'removeCompare';
        } else {
            this.compare.push(id);
            this._hideReturnBlock(id);
            this.requestType = 'addCompare';
        }

        if (parent?.classList.contains('j-parametric-commerce')) {
            this.estateType = 'commerces';
        }

        this.compareButtons.forEach((item) => {
            if (item.dataset.id === id && item.dataset.type) {
                this.estateType = item.dataset.type;
            }
        });

        const compareData = new FormData();

        compareData.append('requestType', this.requestType);
        compareData.append('estateType', this.estateType);
        compareData.append('id', id);

        axios.post(this.action, compareData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;
                    const count = this.data.compare || 0;

                    observer.publish('compare:update', count);
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /**
     * Показывает блок для возврата квартиры в сравнении (если квартира не задизейблена)
     * @param {string} id - id элемента
     * @private
     */
    _showReturnBlock(id) {
        if (!this.returnBlocks.length || this.parent?.classList.contains('is-disabled')) {
            return;
        }

        const returnBlock = this.returnBlocks.find((item) => {
            return item.id === id;
        });

        if (!returnBlock) {
            return;
        }

        returnBlock.block.classList.add('is-active');
    }

    /**
     * Скрывает блок для возврата квартиры в сравнение
     * @param {string} id - id элемента
     * @private
     */
    _hideReturnBlock(id) {
        if (!this.returnBlocks.length) {
            return;
        }

        const returnBlock = this.returnBlocks.find((item) => {
            return item.id === id;
        });

        if (!returnBlock) {
            return;
        }

        returnBlock.block.classList.remove('is-active');
    }

    _setState() {
        if (!this.compare.length || !this.compareButtons) {
            return;
        }


        this.compareButtons.forEach((item) => {
            const isExist = this.compare.findIndex((element) => {
                return element === item.dataset.id;
            });

            if (isExist < 0) {
                return;
            }

            const tooltip = item.querySelector('.j-button__tooltip');

            item.classList.add(this.activeClass);
            this._setTooltip(tooltip, item.classList.contains(this.activeClass));
        });
    }

    _checkIsDisabledFlat(button) {
        this.parent = button.closest('.j-compare-flat.is-disabled');

        if (!this.parent) {
            return;
        }

        this.parent.style.pointerEvents = 'none';
    }
}

export default CompareButton;
